import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Typist from 'react-typist-component';
import { Jumbotron } from "./migration";


const MainBody = React.forwardRef(
  ({ gradient, title, message, icons }, ref) => {
    const [imageSrc, setImageSrc] = useState(null);
    const inputRef = React.useRef(null);

    // Available sticker images from src/assets/badges
    const availableBadges = [
      { key: '1', label: '1', src: require("../../assets/badges/1.png") },
      { key: '2', label: '2', src: require("../../assets/badges/2.png") },
      { key: '3', label: '3', src: require("../../assets/badges/3.png") },
      { key: '4', label: '4', src: require("../../assets/badges/4.png") },
      { key: '5_1', label: '5_1', src: require("../../assets/badges/5_1.png") },
      { key: '6', label: '6', src: require("../../assets/badges/6.png") },
      { key: '7', label: '7', src: require("../../assets/badges/7.png") },
      { key: '8', label: '8', src: require("../../assets/badges/aws_cert.png") },
      { key: '9', label: '9', src: require("../../assets/badges/db_spark.png") },
      { key: '10', label: '10', src: require("../../assets/badges/technochamp.jpg") },
      { key: '11', label: '11', src: require("../../assets/badges/EOY.jpeg") },
      { key: '12', label: '12', src: require("../../assets/badges/SIH.png") },

    ];

    // If you prefer a default sticker, uncomment below or set programmatically
    // useEffect(() => { setImageSrc(availableBadges[0].src); }, []);

    useEffect(() => {
      return () => {
        if (imageSrc && imageSrc.startsWith("blob:")) {
          URL.revokeObjectURL(imageSrc);
        }
      };
    }, [imageSrc]);

    const handleFile = (e) => {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      // allow PNG/SVG/WebP for transparency
      const url = URL.createObjectURL(file);
      // revoke previous blob URL
      setImageSrc((prev) => {
        if (prev && prev.startsWith("blob:")) URL.revokeObjectURL(prev);
        return url;
      });
    };

    const handleSelectBadge = (src) => {
      // if previously set a blob URL, revoke it
      setImageSrc((prev) => {
        if (prev && prev.startsWith("blob:")) URL.revokeObjectURL(prev);
        return src;
      });
    };

//     const clearImage = () => {
//       setImageSrc((prev) => {
//         if (prev && prev.startsWith("blob:")) URL.revokeObjectURL(prev);
//         return null;
//       });
//     };

    return (
      <Jumbotron
        fluid
        id="home"
        style={{
          background: `linear-gradient(136deg,${gradient})`,
          backgroundSize: "1200% 1200%",
          position: "relative", // allow absolutely positioned right-side image
        }}
        className="title bg-transparent bgstyle text-light min-vh-100 d-flex align-content-center align-items-center flex-wrap m-0"
      >
        {/* Right-side big uploaded image */}
        <div
          style={{
            position: "absolute",
            right: "4%",
            top: "12%",
            width: "34vw",
            maxWidth: "640px",
            height: "64vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none", // image itself non-interactive
          }}
        >
          {imageSrc ? (
            <img
              src={imageSrc}
              alt="Sticker"
              style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", background: "transparent" }}
            />
          ) : (
            <div style={{ color: "rgba(255,255,255,0.6)", textAlign: "center", padding: 8 }}>
              Select a badge from below strip
            </div>
          )}
        </div>

        {/* Right-side selector & upload controls (left-aligned) */}
        <div style={{ position: "absolute", right: "4%", top: "78%", width: "34vw", maxWidth: "640px", pointerEvents: "auto", display: 'flex', gap: 8, justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column' }}>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', padding: 4, justifyContent: 'flex-start' }}>
            {availableBadges.map(b => (
              <button key={b.key} onClick={() => handleSelectBadge(b.src)} aria-label={`Select sticker ${b.label}`} style={{ background: 'transparent', border: 'none', padding: 0 }}>
                <img src={b.src} alt={b.label} style={{ width: 56, height: 56, objectFit: 'contain', opacity: 0.95 }} />
              </button>
            ))}
          </div>

          <div>
            <input
              ref={inputRef}
              type="file"
              accept="image/png,image/svg+xml,image/webp"
              onChange={handleFile}
              style={{ display: "none" }}
            />
{/*             <button className="btn btn-outline-light" onClick={() => inputRef.current && inputRef.current.click()} aria-label="Upload transparent image"> */}
{/*               Upload */}
{/*             </button> */}
{/*             <button className="btn btn-outline-light ms-2" onClick={clearImage} aria-label="Clear selected image"> */}
{/*               Clear */}
{/*             </button> */}
          </div>
        </div>

        <div id="stars"></div>
        <Container className="text-center">
          {/* Stats Section */}
          <div className="d-flex justify-content-start gap-5 mb-4" style={{ transform: 'translateX(-8%) translateY(80%)' }}>
            <div className="text-start">
              <h1 className="fw-light" style={{ fontSize: '5.5rem', lineHeight: 1 }}>+$1M</h1>
              <p className="fw-light" style={{ fontSize: '1rem', lineHeight: 1 , transform: 'translateX(10%)'}}>Total Business Savings</p>
            </div>
            <div className="text-start">
              <h2 className="fw-light" style={{ fontSize: '5.5rem', lineHeight: 1 }}>+27</h2>
              <p className="fw-light" style={{ fontSize: '1rem', lineHeight: 1, transform: 'translateX(10%)'}}>Projects Migrated on Cloud</p>
            </div>
          </div>

          {/* Hello Greeting */}
            <h1 ref={ref} className="display-1 fw-light mb-2 text-start" style={{ fontSize: '25rem', lineHeight: 1, transform: 'translateX(-10%) translateY(+10%)' }}>
              Hello
            </h1>

          {/* Subtitle */}
          <p className="display-1 fw-light" style={{ fontSize: '2rem', lineHeight: 1, transform: 'translateX(-35%) translateY(+60%)'}}>
            — It's {title} a Lead Data Engineer
          </p>

          {/* Original Typist Message */}
<Typist>
  <div className="lead typist text-start" style={{ marginTop: '2rem', transform: 'translateX(-5.5%)' }}>
    {message}
  </div>
</Typist>

          {/* Social Icons */}
          <div className="p-5">
            {icons.map((icon, index) => (
              <a
                key={`social-icon-${index}`}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
              >
                <i className={`fab ${icon.image}  fa-3x socialicons`} />
              </a>
            ))}
          </div>

          {/* More About Me Button */}
          <a
            className="btn btn-outline-light btn-lg "
            href="#aboutme"
            role="button"
            aria-label="Learn more about me"
          >
            More about me
          </a>

          {/* Scroll Down Text */}
          <div className="mt-5 pt-3">
            <p className="text-muted small">
              Scroll down ↓
            </p>
          </div>
        </Container>
      </Jumbotron>
    );
  }
);

export default MainBody;

